import React from 'react';
import { Zap } from 'lucide-react';
import { useWhatVervestacksContent } from '../../../hooks/useWhatVervestacksContent';
import WhatVervestacksPanelBody from './subComponents/whatVervestacks/WhatVervestacksPanelBody';
import { PanelError, PanelLoading } from './subComponents/whatVervestacks/whatVervestacksUi';

const WhatVervestacksTab = ({ country }) => {
  const { loading, error, panel, displayName, source, yamlFile, viewModel } =
    useWhatVervestacksContent(country);

  if (!country) {
    return null;
  }

  const iso = country.iso_code?.toUpperCase();
  const simulatorHref = iso ? `/country/${iso}/simulator` : '#';

  return (
    <div className="w-full min-w-0 overflow-x-hidden px-2 md:px-4 lg:px-6 py-2 md:py-4 lg:py-6">
      <div className="tab-content w-full min-w-0 space-y-4 md:space-y-6">
        <header className="card p-4 md:p-6 bg-gradient-to-br from-violet-50 via-white to-indigo-50 border-indigo-100">
          <div className="flex items-start gap-3">
            <div className="p-2.5 bg-gradient-primary rounded-lg shadow-sm shrink-0">
              <Zap className="h-6 w-6 text-white" />
            </div>
            <div className="min-w-0">
              <h2 className="text-lg md:text-2xl font-bold text-gray-900">
                What VerveStacks can do
              </h2>
              {yamlFile && (
                <p className="text-xs text-gray-500 mt-1 font-mono">
                  {yamlFile}
                  {source === 'iso' && panel?.last_updated && ` · ${panel.last_updated}`}
                </p>
              )}
            </div>
          </div>
        </header>

        {loading && <PanelLoading />}
        {error && !loading && <PanelError message={error} />}

        {!loading && !error && viewModel && (
          <WhatVervestacksPanelBody
            viewModel={viewModel}
            simulatorHref={simulatorHref}
            countryIso={iso}
          />
        )}
      </div>
    </div>
  );
};

export default WhatVervestacksTab;
